import { render, staticRenderFns } from "./zhuanzuoyou.vue?vue&type=template&id=16dce3ca&scoped=true&"
import script from "./zhuanzuoyou.vue?vue&type=script&lang=js&"
export * from "./zhuanzuoyou.vue?vue&type=script&lang=js&"
import style0 from "./zhuanzuoyou.vue?vue&type=style&index=0&id=16dce3ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dce3ca",
  null
  
)

export default component.exports